import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType, _single } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _AddPayment, _PaymentTurn, _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../theme/Component/usePaginator';
import { YearSelector } from '../../../core/shared/inputs/YearSelector';
import { MonthConstantsEditor } from '../../RemoteAbstractAction/editors/MonthConstantsEditor';
import { AccountEditor } from '../../editor/AccountEditor';
import { SelectStateConst } from '../../Talentohumano/GestionTH/PaymentAccount/SelectStateConst';
import { BasicButton } from '../../theme/Component/BasicButton';
import { DocumentStorageEditor } from '../../contabilidad/bodegaDocumentos/DocumentStorageEditor';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const PaymentTurnEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_PaymentTurn)
    const [id, setID] = useState(null);
    const AddPayment = useDataBean(_AddPayment);
    const [add, setadd] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const paginador = usePaginator();
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [idAccount, setidAccount] = useState<number>(null)
    const [state, setstate] = useState<number>(null)
    const modal = useModal("Tipo Actividad", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])
    const veradd = () => {

        setadd({ ...add, "view": true });
    }
    const addPaymentAccountToPaymentTurn = () => {

        AddPayment.instance.addPaymentAccountToPaymentTurn(AddPayment.bean.Year, AddPayment.bean.IDDocument, AddPayment.bean.DocumentDate, AddPayment.bean.Code, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Enrutado');
                    // setResponse(resp);
                    getLista();
                    setadd({ ...add, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDPaymentTurn == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getPaymentTurnCatalog(year, month, idAccount, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'Turno', property: 'IDPaymentTurn', visible: true },
        { title: 'Fecha Turno', property: 'Since', visible: true },
        { title: 'ID Cuenta por Pagar', property: 'IDPaymentAccount', visible: true },
        { title: 'Fecha Cuenta por Pagar', property: 'PaymentAccountDate', visible: true },
        { title: 'Beneficiario', property: 'AccountName', visible: true },
        { title: 'Estado Cuenta por Pagar', property: 'StateName', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Recurso"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                    </div>
                    <div className="col-md-4">
                        <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                    </div>
                    <div className="col-md-4">
                        <AccountEditor label="Tercero" idAccount={idAccount} onChange={(e) => { setidAccount(e.IDAccount) }}></AccountEditor>
                    </div>
                    <div className="col-md-4">
                        <SelectStateConst label='Estado de la Operación' idSelector={state} onChange={(e) => { setstate(parseInt(e)) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={veradd}>
                            Enturnar Cuenta por Pagar
                        </BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDPaymentTurn); modal.close(); }}></BasicTable>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={add} updateModal={setadd} eventModal={addPaymentAccountToPaymentTurn}>
                            <div className="row">
                                <div className="col-md-12">
                                    <YearSelector value={AddPayment.bean.Year} tittle="Año" onChange={(e) => { AddPayment.setBean({ ...AddPayment.bean, "Year": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <DocumentStorageEditor label='Documento' onChange={(e) => { AddPayment.setBean({ ...AddPayment.bean, "IDDocument": e.IDDocument, "DocumentDate": e.DocumentDate }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Código</label>
                                    <input type="text" className="form-control" name="Code" value={AddPayment.bean.Code} onChange={AddPayment.handleChange} />
                                </div>
                                {/* <div className="col-md-12">
                                                    <PrintJson json={response}/>
                                                </div> */}
                            </div>
                        </Modal>
                    </div>
                </div>

            </Modal>
        </>
    )
}